import { useState } from 'react';
import { ElWrapper } from './atoms';
import styled from 'styled-components';
import { TertiaryButton } from '@ardoq/button';
import { AddIcon, IconSize } from '@ardoq/icons';
import { FIELD_SELECTOR } from '@ardoq/forms';
import { CreateNodeInput } from './CreateNodeInput';
import { WithPopover } from '@ardoq/popovers';
import { useMetamodelEditorContext } from '../state';

export const AddLeafButtonWrapper = styled(ElWrapper)`
  ${FIELD_SELECTOR} {
    width: 200px;
  }
`;

type AddLeafButtonProps = {
  parentMetamodelTypeId: string;
};

export const AddLeafButton = ({
  parentMetamodelTypeId,
}: AddLeafButtonProps) => {
  const [isInEditMode, setIsInEditMode] = useState<boolean>(false);
  const { labels } = useMetamodelEditorContext();

  return (
    <AddLeafButtonWrapper
      $isReadOnly={false}
      data-test-id="metamodel-editor-add-child-node"
    >
      {isInEditMode ? (
        <CreateNodeInput
          parentMetamodelTypeId={parentMetamodelTypeId}
          onEditEnd={() => setIsInEditMode(false)}
        />
      ) : (
        <TertiaryButton onClick={() => setIsInEditMode(true)}>
          <WithPopover content={labels.addLeafTooltip}>
            <AddIcon iconSize={IconSize.SMALL} />
          </WithPopover>
        </TertiaryButton>
      )}
    </AddLeafButtonWrapper>
  );
};
